module.exports = __webpack_public_path__ + "b21c4d62c0953e25ea3e5a8aec184eb4.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/message-16-info.png
// module id = 223
// module chunks = 0